// extracted by css-extract-rspack-plugin
export default {"inputLabel":"Label-module__inputLabel__Y2qdlu2"};